export {
    SuiPopupModule,
    IPopup,
    SuiPopupConfig,
    IPopupConfig,
    ITemplatePopupConfig,
    ITemplatePopupContext,
    PopupTrigger,
    SuiPopup,
    SuiPopupDirective
} from "./index";

import { PositioningPlacement } from "../../misc/util/index";
export { PositioningPlacement as PopupPlacement };
